
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cards",
      function () {
        return require("private-next-pages/cards.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cards"])
      });
    }
  